<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 09:43:37
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 14:01:52
 * @Description: 重点环节专项审计报告 2019
 -->
<template>
  <div class="financial-reports-2019">
    <img :src="item" alt="" srcset="" v-for="(item, index) in imgList" :key="index" />
  </div>
</template>
<script>
export default {
  name: 'financial-reports-2018',
  computed: {
    imgList() {
      let arr = [];
      for (let i = 1; i < 12; i++) {
        const index = i < 10 ? `0${i}` : i;
        arr.push(`https://files.jinr.com/jinr-index/financial-reports/important-2019/${index}.jpg`);
      }
      return arr;
    }
  }
};
</script>
